// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-50f31fbd] .dx-button {\n  width: 100%;\n}\n[data-v-50f31fbd] .dx-button .dx-button-text {\n  width: 100%;\n  text-align: start;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
